import React, { useState, useRef, useEffect } from 'react';
import Text from './TextMessage';
import Range from './RangeMessage';
import TextInput from './TextInputMessage';
import ThankYouDialog from '../dialogs/ThankYouDialog';
import '../../../stylesheets/triagebot/Nps.scss';
import { useTiming } from '../TimingContext';
import { useCardLoadTiming } from '../hooks/useCardLoadTiming';
import { formatCardLoadTiming } from '../utils';

const cdoName = process.env.REACT_APP_CDO_NAME;

const NPSMessage = ({ message, sendMessage, disabled, selfCare911ERSelected, selectedButtonRedirectUrl, closeToast, onFeedbackSubmit }) => {
    const [cardShowing, setCardShowing] = useState(1);
    const [npsValue, setNpsValue] = useState(10);
    const [comment, setComment] = useState('');
    const [showThankYouDialog, setShowThankYouDialog] = useState(false);
    const { timings } = useTiming();
    const isOpenCdo = (cdoName).toLowerCase() === 'open';
    const isCdoDisabled = disabled || cardShowing === 2;
    const isPopupOpen = typeof closeToast === 'function';

    const showFeedbackCard = message && message.data[1] && message.data[1].feedbackCard;
    const pageHeader = message?.data[1]?.npsCard?.data[0]?.pageHeader;
    const quesText = message?.data[1]?.npsCard?.data[0]?.quesText;
    const cardName = (message.data && message.data[0] && message.data[0].question_id) ? message.data[0].question_id : "NpsRatingFeedback";

    sendMessage = (typeof sendMessage === 'function')
        ? sendMessage
        : () => { }

    const cardMessages = message && Array.isArray(message.data) && message.data.length > 1
        ? message.data[1]
        : {}

    const npsMessage = cardMessages.npsCard
        ? cardMessages.npsCard
        : {}

    const feedbackMessage = cardMessages.feedbackCard
        ? cardMessages.feedbackCard
        : {}

    const openThankYouPopupHeaderText = cardMessages.openThankyoupopupheaderText || '';
    const openThankYouPopupBodyText = cardMessages.openThankyoupopupbodyText || '';
    const openThankYouButtonText = cardMessages.openThankyoubuttonText || '';
    const openHomeRedirectUrl = cardMessages.openhomeredirecturl || '';
    const closeButtonText = cardMessages.closeButton || 'Close'

    const thankYouMessages = cardMessages.thankYouCards && Array.isArray(cardMessages.thankYouCards)
        ? cardMessages.thankYouCards
        : []

    const BLANK_THANK_YOU = { type: 'textcard', text: 'feedback' };

    const defaultThankYou = thankYouMessages.find(message => message.thankYouType === 'feedback')

    const npsThankYou = thankYouMessages.find(message => message.thankYouType === 'nps')

    const noCommentThankYou = thankYouMessages.find(message => message.thankYouType === 'noComment')

    var thankYouMessage = defaultThankYou && defaultThankYou.card
        ? defaultThankYou.card
        : BLANK_THANK_YOU

    if (npsValue < 9)
        thankYouMessage = npsThankYou && npsThankYou.card
            ? npsThankYou.card
            : BLANK_THANK_YOU

    if (!comment)
        thankYouMessage = noCommentThankYou && noCommentThankYou.card
            ? noCommentThankYou.card
            : BLANK_THANK_YOU

    const sendingMessage = (type, text, value) => {
        if (type === 'go-back') {
            setCardShowing(value)
            return;
        }

        if (cardShowing === 1) {
            setNpsValue(npsValue);
            if (showFeedbackCard !== undefined) {
                setComment(text);                
                let response = {
                    nps: npsValue,
                    comment: text
                }
                sendMessage(type, JSON.stringify(response), response, cardName);
                sendMessage('nps-answered', true, true);
                setCardShowing(2);

                return;
            }
            else {
                let response = {
                    nps: npsValue,
                    comment: ""
                };
                sendMessage(type, JSON.stringify(response), response, cardName);
                sendMessage('nps-answered', true, true);
                setCardShowing(2);
            }
            return;
        }
    }

    const handleThankYouDialogClose = () => {
        setShowThankYouDialog(false);
    }

    const handleThankYouDialogContinue = () => {
        setShowThankYouDialog(false);
        setCardShowing(2);
    }

    const handleNpsSubmit = () => {
        setShowThankYouDialog(true);
    }

    const messageRef = useRef();

    useEffect(() => {
        if (messageRef.current) {
            messageRef.current.scrollIntoView(
                {
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest'
                })
        }

    }, []);

     const { logTiming } = useTiming();
        useCardLoadTiming({
                    sentAt: isOpenCdo ? null : message._sentAt,
                    cardName,
                    logTiming,
                    formatCardLoadTiming
                });


    if (isOpenCdo) {
        return (
            <div className={`nps card open-cdo${isPopupOpen ? ' pop-up-open' : ''}${isCdoDisabled ? ' disabled' : ''}`} ref={messageRef}>
                <div className='content'>
                    <div>
                        {pageHeader && <h2 className='ov-page-header'>{pageHeader}</h2>}
                        {quesText && <p className='ov-ques-text'>{quesText}</p>}
                        <Range
                            message={npsMessage}
                            sendMessage={sendingMessage}
                            npsValue={npsValue}
                            setNpsValue={setNpsValue}
                            disabled={isCdoDisabled}
                        />
                        <TextInput
                            message={feedbackMessage}
                            sendMessage={sendingMessage}
                            disabled={isCdoDisabled}
                            selfCare911ERSelected={selfCare911ERSelected}
                            selectedButtonRedirectUrl={selectedButtonRedirectUrl}
                            closeToast={closeToast}
                            onSubmit={handleNpsSubmit}
                            onFeedbackSubmit={onFeedbackSubmit}
                        />
                    </div>
                </div>
                {!isPopupOpen && selfCare911ERSelected && (
                    <ThankYouDialog
                        isDialogOpen={showThankYouDialog}
                        onClose={handleThankYouDialogClose}
                        onContinue={handleThankYouDialogContinue}
                        redirectUrl={openHomeRedirectUrl}
                        headerText={openThankYouPopupHeaderText}
                        bodyText={openThankYouPopupBodyText}
                        buttonText={openThankYouButtonText}
                        closeButton = {closeButtonText}
                    />
                )}
            </div>
        );
    }

    return (
        <div className='nps card' ref={messageRef}>
            {
                cardShowing < 2 && showFeedbackCard !== undefined
                    ?
                    <div>
                        <div className='header' style={{ color: `var(--primary-color)` }} id='nps-card'>
                            <h2 className='headerText'>{pageHeader}</h2>
                        </div>
                        <p style={{ marginBottom: '30px' }} >{quesText}</p>
                    </div>
                    :
                    <></>
            }
            {(cardShowing === 2) && <Text message={thankYouMessage} />}
            {(cardShowing === 1) && (
                <div>
                    <Range
                        message={npsMessage}
                        sendMessage={sendingMessage}
                        npsValue={npsValue}
                        setNpsValue={setNpsValue}
                        disabled={disabled}
                    />
                    <TextInput
                        message={feedbackMessage}
                        sendMessage={sendingMessage}
                      
                        disabled={disabled}
                        selfCare911ERSelected={selfCare911ERSelected}
                        selectedButtonRedirectUrl={selectedButtonRedirectUrl}
                        closeToast={closeToast}
                    />
                </div>
            )}
        </div>
    )
}

export default NPSMessage;